import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'Home',
      component: () => import('./views/Home.vue'),
      meta: {
        //requireAuth: true
      }
    },
    {
      path: '/administration',
      name: 'Administration',
      component: () => import('./views/Administration.vue'),
      children: [
        {
          path: 'organization/:organizationId',
          name: 'AdministrationOrganization',
          component: () => import('./views/administration/Organization.vue')
        },
        {
          path: 'organizations',
          name: 'AdministrationOrganizations',
          component: () => import('./views/administration/Organizations.vue')
        },
        {
          path: 'people',
          name: 'AdministrationPeople',
          component: () => import('./views/administration/People.vue')
        }
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/profiles',
      name: 'Profiles',
      component: () => import('./views/Profiles.vue'),
      children: [{
          path: 'organization',
          name: 'ProfilesOrganization',
          component: () => import('./views/profiles/Organization.vue')
        },
        {
          path: 'asset',
          name: 'ProfilesAsset',
          component: () => import('./views/profiles/Asset.vue')
        },
        {
          path: 'identity',
          name: 'ProfilesIdentity',
          component: () => import('./views/profiles/Identity.vue')
        },
        {
          path: 'documenttype',
          name: 'ProfilesDocumentType',
          component: () => import('./views/profiles/DocumentType.vue')
        },
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('./views/Settings.vue'),
      children: [{
        path: 'counters',
        name: 'SettingsCounters',
        component: () => import('./views/settings/Counters.vue')
      }, {
        path: 'systemlog',
        name: 'SettingsSystemLog',
        component: () => import('./views/settings/SystemLog.vue')
      }, {
        path: 'database',
        name: 'SettingsDatabase',
        component: () => import('./views/settings/Database.vue')
      }],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/accessdenied',
      name: 'AccessDenied',
      component: () => import('./views/AccessDenied.vue'),
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: () => import('./views/SignIn.vue'),
    }
  ]
})

// Global route guard
router.beforeEach(async (to, from, next) => {
  await Vue.nextTick();
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (to.matched.some(record => {
      if (record.meta.requireRoles) {
        return record.meta.requireRoles.some(r => {
          if (router.app.$msal.data.user.idToken.roles) {
            if (router.app.$msal.data.user.idToken.roles.includes(r)) {
              return true;
            }
            else 
            {
              console.error(router.app.$msal.data.user.idToken.roles); /* eslint-disable-line no-console */
              return false;
            }
          } else {
            return false;
          }
        });
      } else {
        return true;
      }
    })) {
    next();
  } else {
    console.warn('router: user is not authorized'); /* eslint-disable-line no-console */
    router.push({
      name: 'SignIn'
    });
  }
  } else {
    next();
  }
});

export default router;